
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/zoomMode/components/SectionsDropZoneContainer/SectionsDropZoneContainer.scss.css.virtualfile';
        module.exports = {"container":"_container_f4pcx_1"};